import { render, staticRenderFns } from "./askToExpert.vue?vue&type=template&id=091019d4&scoped=true"
import script from "./askToExpert.vue?vue&type=script&lang=js"
export * from "./askToExpert.vue?vue&type=script&lang=js"
import style0 from "./askToExpert.vue?vue&type=style&index=0&id=091019d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091019d4",
  null
  
)

export default component.exports